import Service from "@/utils/api/service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "EditCheckupRequest",
  data() {
    return {
      isFetching: true,
      payload: {},
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
  },
  created() {
    setTimeout(async () => {
      await this.getDetail();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListCheckupRequest",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    async getDetail() {
      await Service.listService(this.$route.params.id).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getDetail();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.payload = response?.data ?? "";
        }

        this.isFetching = false;
      });
    },
  },
};
